// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_no-5";
export var filledCircle = "_no-4";
export var historyEntry = "_no-3";
export var messageSideLeft = "_no-1";
export var messageSideRight = "_no-2";
export var orderTrackingCarouselWrapper = "_no-6";
export var orderTrackingInfoContainer = "_no-0";